import { Component, ElementRef, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertBoxComponent } from 'src/app/shared/components/alert-box/alert-box.component';
import { ConfirmationBoxComponent } from 'src/app/shared/components/confirmation-box/confirmation-box.component';
import { ProjectsService } from '../../services/projects.service';
import { SelectUtil } from 'src/app/core/services/uitls/selectUtil';
import { handlePaginationChangeUtil } from 'src/app/core/services/uitls/navigation.utils';
import { FilterUtilService } from 'src/app/core/services/uitls/filter-utilizer/filter-util.service';
import { FiltersService } from 'src/app/core/services/filters/filters.service';
import { ReplaySubject } from 'rxjs';

@Component({
  selector: 'app-projects-list',
  templateUrl: './projects-list.component.html',
  styleUrls: ['./projects-list.component.scss']
})
export class ProjectsListComponent implements OnInit {

  imgDefault: string = '/assets/images/svg/sort-default.svg'
  imgASC: string = '/assets/images/svg/sort-up.svg';
  imgDesc: string = '/assets/images/svg/sort-down.svg';
  projects: any;
  config: { id: string; itemsPerPage: number; currentPage: any; totalItems: any; };
  page: number = 1;
  page_size: number = 20;
  searchValue: any;
  disabledDelete: boolean = true;
  selectedRowsIndex: any[] = [];
  selectedRowsPK: any[] = [];
  deletedProjectPK: any[] = [];
  deletedProjectIndex: any[] = [];
  orderingState: { [key: string]: boolean | null } = {
    shortcode: null,
    name: null,
    active_date: null,
    expiry_date: null
  }
  spinner: boolean = true;
  ordering: any[] = [];
  modelImg: boolean = false;
  imgPath: string = '';
  confirmMsg: string = '';
  pageTitle: string = 'العقود التجارية';
  totalRowsSelected: boolean = false;
  saveDialogRef!: MatDialogRef<AlertBoxComponent>;
  deleteDialogRef!: MatDialogRef<ConfirmationBoxComponent>;
  @ViewChildren('checkBoxList') checkBoxList!: ElementRef<HTMLInputElement>[];
  @ViewChild('selectAllElm') selectAllElm!: ElementRef<HTMLInputElement>;
  currentItemsPerPage!: number;
  @ViewChild('goUp', { static: false }) contentPage!: ElementRef;

  //Filters Variables 
  filterData: unknown;
  filterDataInit = {};
  filterParamsUrl = {};
  filterPage: string = 'ADMIN_CONTRACTS';
  spinnerKey: string = 'spinner';
  destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

  constructor(private projectService: ProjectsService,
    private router: Router,
    private titleService: Title,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private filter: FiltersService,
    private filterUtil: FilterUtilService) {
    this.config = {
      id: 'myPagination',
      itemsPerPage: this.page_size,
      currentPage: this.page,
      totalItems: 0,
    };
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      if (params.page && params.page_size) {
        this.page = Number(params.page)
        this.page_size = Number(params.page_size)
        this.config.currentPage = Number(params.page)
        this.config.itemsPerPage = Number(params.page_size)
      } else {
        this.router.navigate([], {
          queryParams: { page: 1, page_size: 20 },
          queryParamsHandling: 'merge',
        });
      }

      this.filterUtil.clearfilterParams(this.filterParamsUrl);
      this.filterUtil.clearfilterParams(this.filterDataInit);
      if (Object.keys(params).length > 0) {
        this.searchValue = params['query'] ? params['query'] : '';
        this.filterParamsUrl = { ...params };
        this.filterDataInit = { ...params };
      } 
    });
    this.titleService.setTitle('العقود التجارية | عاين');
    this.getProjectFilter();
    this.filterUtil.getSavedFilters(this, this.filterPage);
    this.filter.changeSelectedFilter(this.filterDataInit);
    this.filterUtil.applySelectedFilter(
      this,
      this.getProjects,
      this.spinnerKey
    );
  }

  getProjectFilter() {
    let params = {
      filter_page: this.filterPage,
    };
    this.filter.getFiltersData(params).subscribe(
      (data) => {
        this.filterData = data;
      },
      (error) => {
        this.handleBackendError(error);
      }
    );
  }

  handleBackendError(error: unknown) {
    try {
      console.log(error);
    } catch {
      console.log(error);
    }
  }

  filterFormValues(event: unknown) {
    this.filterParamsUrl = (event as any).filterParamsUrl;
    this.spinner = true;
    this.config.currentPage = 1;
    this.config.itemsPerPage = 20;
    this.getProjects();
  }

  getProjects() {
    let params: any = { ...this.filterParamsUrl };

    params['page'] = this.config.currentPage;
    params['ordering'] = this.ordering;
    params['page_size'] = this.config.itemsPerPage;

    this.totalRowsSelected = false;
    if(this.searchValue) {
      params['query'] = this.searchValue;
    }
    this.projectService.getProjects(params).subscribe(data => {
      this.loadOrders(data);
      this.projects = data.results;
      this.config['totalItems'] = data.count;
      this.currentItemsPerPage = data.results.length;
      this.spinner = false;
    }, error => {
      try {}
      catch {}
    });
  }

  loadOrders(data: { results: any; count: any; }) {
    this.spinner = false;
    this.projects = data?.results;
    this.config['totalItems'] = data.count;
    this.currentItemsPerPage = data.results.length;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: this.filterParamsUrl,
      queryParamsHandling: '',
    });
  }

  addProject() {
    this.router.navigateByUrl('/pages/projects/add');
    this.titleService.setTitle('إضافة مشروع | عاين');
  }

  openProject(id: string) {
    this.router.navigateByUrl("/pages/projects/" + id);
    this.titleService.setTitle('تعديل المشروع #' + id + '  | عاين');
  }

  stopPropagation(event: Event) {
    event.stopPropagation();
  }

  toggleSorting(colNam: string, img: HTMLImageElement) {
    this.ordering = [];
    switch (this.orderingState[colNam]) {
      case null:
        this.orderingState[colNam] = false;
        img.src = this.imgASC;
        break;

      case false:
        this.orderingState[colNam] = true;
        img.src = this.imgDesc;
        break;

      case true:
        this.orderingState[colNam] = null;
        img.src = this.imgDefault
        break;
    }
    for (const [key, value] of Object.entries(this.orderingState)) {
      switch (value) {
        case false:
          this.ordering.push(key);
          break;
        case true:
          this.ordering.push("-" + key);
          break;
      }
    }
    this.getProjects();
  }

  selectAll(event: Event) {
    this.disabledDelete = true;
    SelectUtil.selectAll(event, this);
  }

  quickSearch(event: Event) {
    this.spinner = true;
    this.searchValue = event;
    this.config.currentPage = 1;
    this.config.itemsPerPage = 20;
    this.getProjects();
  }

  deleteSelectedRows() {
    this.deletedProjectPK = this.selectedRowsPK;
    this.deletedProjectIndex = this.selectedRowsIndex;
    this.showDeleteConfirmationBox();
  }

  selectsSingleRow(event: Event, rowPk: string, index: number) {
    this.disabledDelete = true;
    this.totalRowsSelected = false;
    SelectUtil.selectsSingleRow(event, rowPk, index, this);
    if (this.selectedRowsPK.length > 0) {
      this.disabledDelete = false;
    }
  }

  showDeleteConfirmationBox() {
    this.deleteDialogRef = this.dialog.open(ConfirmationBoxComponent, {
      data: {
        id: this.deletedProjectPK,
        index: this.deletedProjectIndex,
        message: 'هل أنت متأكد من حذف المشروع؟'
      }
    });
    this.deleteDialogRef.afterClosed().subscribe(result => {
      if(result) {
        this.delete(result);
      }
    });
  }

  delete(event: { index: number[]; id: number[] }) {
    let index: number[] = event.index;
    let pks: number[] = event.id;
    this.projectService.deleteProject(pks).subscribe(data => {
      for (let i = index.length - 1; i >= 0; i--) {
        let OrderInd = index[i];
        this.projects.splice(OrderInd, 1)
      }
      this.selectedRowsPK = [];
      this.selectedRowsIndex = [];
    },
      (error) => {
        try {
          this.modelImg = false;
          this.imgPath = '../../../../assets/images/svg/refusal-icon-admin.svg';
          this.confirmMsg = '  عذراً لا يمكن حذف المشروع . ‎';
          this.saveDialogRef = this.dialog.open(AlertBoxComponent, {
            data: {
              imgSuccess: this.modelImg,
              message: this.confirmMsg
            },
          });
          this.selectedRowsPK = [];
          this.selectedRowsIndex = [];
        }
        catch {}
      })
  }

  changeToSpecific(event: Event) {
    this.pageChanged(event)
  }
  pageChanged(event: Event) {
    handlePaginationChangeUtil(
      this.contentPage,
      (value: boolean) => this.spinner = value,
      this.router,
      'page',
      event
    );
    this.config.currentPage = event;
    this.totalRowsSelected = false;
    this.getProjects();
  }

  pageSizeChanged(event: number) {
    handlePaginationChangeUtil(
      this.contentPage,
      (value: boolean) => this.spinner = value,
      this.router,
      'page_size',
      event
    );
    this.config.itemsPerPage = event;
    this.getProjects();
  }

  selectTotalRows(event: boolean) {
    this.totalRowsSelected = event;
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
    this.filter.changeSelectedFilter({});
  }

}
